import Container from "@/components/base/Container";
import Reveal from "@/components/feature/Reveal";
import { principles } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section className="w-full bg-background-950 py-14 md:py-20">
      <Container>
        <Reveal className="max-w-2xl">
          <span className="text-xs font-medium tracking-[0.22em] text-accent-400">编辑部怎么做的</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            四条我们从不妥协的规则
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            吃瓜可以快，但复盘不能糙。下面这四条，是每一篇稿子在发布前都要过一遍的门槛。
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-lg bg-background-800 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((item, index) => (
            <Reveal key={item.title} delay={index * 80}>
              <div className="flex h-full flex-col bg-background-950 p-6">
                <span className="font-heading text-3xl font-bold text-background-700">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="mt-5 flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-lg text-foreground-950">
                  <i className={item.icon}></i>
                </span>
                <h3 className="mt-5 font-heading text-base font-semibold text-background-50">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-300">{item.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}